import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Loader2, CheckCircle2, BellPlus } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { productsAPI } from '../services/api';
import { useT, i18n } from '../services/i18n';

// One-click weekly e-mail subscription to new arrivals (all catalogue or the category currently filtered)
const NewArrivalsSubscribe = ({ category, categoryName }) => {
  const { t } = useT();
  const loggedIn = !!localStorage.getItem('token');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  const subscribe = async () => {
    setBusy(true);
    try {
      const r = await productsAPI.subscribeNew({ email: loggedIn ? undefined : email.trim(), category: category || null, lang: i18n.get() });
      setDone(r);
      toast.success(r.created ? t('new.subOk') : t('new.subAlready'));
    } catch (e) { toast.error(e.response?.data?.detail || t('new.subError')); }
    finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex flex-wrap items-center gap-3 bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3 mb-5" data-testid="new-subscribe-done">
        <CheckCircle2 className="text-emerald-600 shrink-0" size={20} />
        <p className="text-sm text-emerald-900 flex-1 min-w-0">{t('new.subDone', { email: done.email, scope: done.category ? (categoryName || done.category_name) : t('new.allCats').toLowerCase() })}</p>
        {loggedIn && <Link to="/mon-compte/alertes" className="text-xs text-emerald-800 underline" data-testid="new-subscribe-manage">{t('new.subManage')}</Link>}
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-3 bg-white border border-orange-200 rounded-xl px-4 py-3 mb-5" data-testid="new-subscribe">
      <span className="w-9 h-9 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center shrink-0"><BellPlus size={18} /></span>
      <div className="flex-1 min-w-[200px]">
        <p className="text-sm font-semibold text-gray-900" data-testid="new-subscribe-title">{category ? t('new.subTitleCat', { name: categoryName || category }) : t('new.subTitleAll')}</p>
        <p className="text-xs text-gray-500">{t('new.subHint')}</p>
      </div>
      {loggedIn ? (
        <Button onClick={subscribe} disabled={busy} className="bg-orange-500 hover:bg-orange-600" data-testid="new-subscribe-button">{busy ? <Loader2 size={15} className="animate-spin mr-1" /> : <Mail size={15} className="mr-1" />} {t('new.subButton')}</Button>
      ) : (
        <form className="flex items-center gap-2 flex-wrap" onSubmit={(e) => { e.preventDefault(); subscribe(); }} data-testid="new-subscribe-form">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('auth.emailPh')} className="w-56 h-9" data-testid="new-subscribe-email" />
          <Button type="submit" disabled={busy || !email.trim()} className="bg-orange-500 hover:bg-orange-600 h-9" data-testid="new-subscribe-button">{busy ? <Loader2 size={15} className="animate-spin mr-1" /> : <Mail size={15} className="mr-1" />} {t('new.subButton')}</Button>
        </form>
      )}
    </div>
  );
};

export default NewArrivalsSubscribe;
